import React, { createContext } from "react";

export const PostContext = createContext();

export function PostProvider({ children, markdownRemark, authorImage }) {
  const { frontmatter, html, timeToRead, fields } = markdownRemark;
  const {
    title,
    tags,
    author,
    heroImage,
    categories,
    dateUpdated,
    customTopics,
    customCTA,
    customContactCTA,
    customContactCTAIcon
  } = frontmatter;
  const { date } = fields;

  const contextValue = {
    html,
    timeToRead,
    title,
    tags,
    author,
    categories,
    date,
    dateUpdated,
    customTopics,
    customCTA,
    customContactCTA,
    customContactCTAIcon,
    heroImage,
    authorImage,
  };

  return (
    <PostContext.Provider value={contextValue}>{children}</PostContext.Provider>
  );
}
